import React from 'react';
import { SystemText } from 'e4shared';
import Panel from 'components/general/panel';

export const Unreviewed = ({ data, setShow }) => {
    if (!data || data.length === 0) return null;

    const st = (path, ...rest) => SystemText(`Home/Widgets/WhatsHappening/Unreviewed/${path}`, ...rest);

    const message = st('Message', data.length);

    return <Panel colour="danger" icon="users" message={message} url="" setShow={setShow} />;
};

export default Unreviewed;
